import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, err: null };
  }

  static getDerivedStateFromError(err) {
    return { hasError: true, err };
  }

  componentDidCatch(error, info) {
    // Surface to the console for dev; production would log to a service.
    // eslint-disable-next-line no-console
    console.error('EPK ErrorBoundary caught:', error, info);
  }

  reset = () => this.setState({ hasError: false, err: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream p-6" data-testid="error-boundary">
        <div className="max-w-lg w-full border-4 border-ink shadow-print bg-cream p-6">
          <div className="font-display text-2xl uppercase text-oxblood mb-2">Something broke.</div>
          <p className="font-body text-ink/80 text-sm mb-4">
            The page hit an unexpected error. The band's content is safe. Try reloading.
            If it keeps happening, contact your developer.
          </p>
          <div className="flex gap-3">
            <button className="btn-print" onClick={() => window.location.reload()} data-testid="error-reload">Reload</button>
            <button className="btn-print secondary" onClick={this.reset} data-testid="error-dismiss">Dismiss</button>
          </div>
          {process.env.NODE_ENV !== 'production' && this.state.err && (
            <pre className="text-xs text-ink/60 mt-4 overflow-auto max-h-40">{String(this.state.err)}</pre>
          )}
        </div>
      </div>
    );
  }
}
